import { ABSENCE_TYPES } from '../../constants';

export function absenceTypeLabel(id: string): string {
  return ABSENCE_TYPES.find((t) => t.id === id)?.label || 'Absence';
}

export function absenceBrickId(typeId: string): string {
  return `__abs_${typeId}__`;
}

export function isAbsenceBrick(id: unknown): id is string {
  return typeof id === 'string' && id.startsWith('__abs_');
}

export function absenceTypeFromBrick(id: string): string {
  return id.replace(/^__abs_/, '').replace(/__$/, '');
}
